
import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Gamepad, MapPin, BookOpen } from "lucide-react";
import CTAButton from "@/components/CTAButton";

// 设计1：奇幻冒险风格 - 突出剧本杀的情感与沉浸体验
const MainCTASection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 relative overflow-hidden mb-16">
      <div className="absolute inset-0 bg-gradient-to-r from-[#1a1a1a] via-black to-[#1a1a1a] z-0"></div>
      <div className="container mx-auto px-6 relative z-10">
        <div className="rounded-xl p-10 md:p-16 text-center relative overflow-hidden">
          {/* 装饰性背景元素 */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 left-1/4 w-40 h-40 rounded-full bg-indigo-600 blur-[100px]" />
            <div className="absolute bottom-10 right-1/4 w-60 h-60 rounded-full bg-anzir blur-[100px]" />
            <div className="absolute top-1/3 left-1/3 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 rounded-full bg-purple-600/50 blur-[80px]" />
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="relative z-10"
          >
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-white leading-tight">
              {t('cta.main.title', '准备好开始你的冒险之旅了吗？')}
            </h2>

            <p className="text-lg text-white/80 max-w-2xl mx-auto mb-10">
              {t('cta.main.description', '探索无尽的角色与故事，从魔幻冒险到青春校园，从古风武侠到未来科幻，每一场体验都将成为难忘的回忆。')}
            </p>

            <div className="flex flex-col sm:flex-row gap-5 justify-center items-center">
              <CTAButton
                to="/library"
                className="bg-gradient-to-r from-purple-600 to-anzir text-white font-medium px-8 py-4 rounded-lg text-lg shadow-lg shadow-purple-500/20 hover:shadow-purple-500/40 transition-all"
                icon={<Gamepad className="w-5 h-5" />}
              >
                {t('hero.online.cta', '线上体验')}
              </CTAButton>

              <CTAButton
                to="/stores"
                variant="outline"
                className="border-2 border-white/20 hover:border-white/40 text-white font-medium px-8 py-4 rounded-lg text-lg backdrop-blur-sm transition-all"
                icon={<MapPin className="w-5 h-5" />}
              >
                {t('hero.offline.cta', '寻找场馆')}
              </CTAButton>

              <CTAButton
                to="/what-is-mysteryact"
                variant="secondary"
                className="bg-white/10 hover:bg-white/20 text-white font-medium px-8 py-4 rounded-lg text-lg transition-all"
                icon={<BookOpen className="w-5 h-5" />}
              >
                {t('whatIs.learnMore', '了解更多')}
              </CTAButton>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MainCTASection;
